// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { clientsRequested, clientsRequestFailed, clientsRequestSucceeded } from './select-client.actions';
import { ClientsService } from '../../../core/services/clients.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { SnackbarService } from '@coa/app/libs/services/snackbar.service';

@Injectable()
export class SelectClientEffects {

  clientsRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(clientsRequested),
      mergeMap(() => this.clientsService.getClients().pipe(
        map((clientsResponse) => clientsRequestSucceeded({clientsResponse})),
        catchError(() => of(clientsRequestFailed())),
      )),
    ),
  );

  clientsRequestFailed$ = createEffect(() =>
    this.actions$.pipe(
      ofType(clientsRequestFailed),
      tap(() => {
        this.snackbarService.open(marker('Error occurred while loading client list'));
      }),
    ), {dispatch: false},
  );

  constructor(private actions$: Actions,
              private store$: Store,
              private snackbarService: SnackbarService,
              private clientsService: ClientsService) {
  }
}
